import { useEffect, useState } from 'react';

import {
  DragDropContext,
  Draggable,
  DraggableProvided,
  Droppable,
  DroppableProps,
} from 'react-beautiful-dnd';

const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return <></>;
  }

  return <Droppable {...props}>{children}</Droppable>;
};

export { DragDropContext, StrictModeDroppable as Droppable, Draggable };
export type { DraggableProvided };
